import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { ConditionalSplitTransformation } from 'app/model/dataflow/conditionalsplittransformation';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { FLOW } from 'app/model/adapters/dataflow/IDataflow';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ConditionalSplitTransformation),
    asynchronous: true
})
export class ConditionalSplitTransformationAdapter extends TransformationAdapter<ConditionalSplitTransformation> {
    public async getDslScript(conditionalSplitTransformation: ConditionalSplitTransformation): Promise<string> {
        const expressions = conditionalSplitTransformation.conditionExpressions
            .filter((conditionExpression) => !conditionExpression.isDefault)
            .map((conditionExpression) => {
                return DataFlowExpressionUtils.wrapExpressionWithEmptyValue(
                    conditionExpression.dataFlowExpression.expression
                );
            });
        // This is used instead of this._getOutputStreams(conditionalSplitTransformation) in order to make sure catch all stream is last
        const outputStreams = conditionalSplitTransformation.conditionExpressions.map((conditionExpression) => {
            return conditionExpression.outputStream.name;
        });
        const expressionsScript = expressions.join(',\n\t');
        const partition = TransformationAdapter.getPartitionDslScript(conditionalSplitTransformation);

        const knownProps = `${expressionsScript}${expressionsScript ? ',\n\t' : ''}disjoint: ${
            conditionalSplitTransformation.disjoint
        }${partition ? ',\n\t' : ''}${partition}`;
        const unknownProps = this._getUnknownProps(conditionalSplitTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(conditionalSplitTransformation)} ${
                ConditionalSplitTransformation.MODEL.name
            }(${transformationData}) ` + `${FLOW} ${conditionalSplitTransformation.name}@(${outputStreams.join(', ')})`
        );
    }
}
